import { useState, useEffect } from 'react'
import { toast } from 'react-toastify';
import { FilterMatchMode } from 'primereact/api'
import { useDispatch } from 'react-redux';
import { handleLoader, handleNotFound } from 'redux/counterSlice';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Tag } from 'primereact/tag';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import DataShowModal from 'components/DataShowModal';
import { getDataByHostURL, getDownloadFile } from 'services/sftpService';
import { InputText } from 'primereact/inputtext';
import { Calendar } from 'primereact/calendar';
import { Dropdown } from 'primereact/dropdown';
import { formateDate } from "utils/formatDate";
import { IconField } from 'primereact/iconfield';
import { InputIcon } from 'primereact/inputicon';
import { getDataForConnectors } from 'services/pdfUploadService';
const moment = require('moment');

const FileConfig = () => {
  // const {
  //   handleSubmit,
  //   formState: { errors },
  //   control
  // } = useForm<any>({ defaultValues: {} })

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const params = useParams()
  const location = useLocation();
  const connState = location.state as any;

  const [urlList, setUrlList] = useState<any>([])
  // const [urlList2, setUrlList2] = useState<any>([]);
  const [extractList, setExtractList] = useState<any>([]);
  const [dynamicId, setDynamicId] = useState<any>("");
  const [dynamicData, setDynamicData] = useState<any>("");
  const [visible, setVisible] = useState(false);
  const [globalFilterValue, setGlobalFilterValue] = useState('');
  const [filters, setFilters] = useState<{ [s: string]: any }>();
  const [dates, setDates] = useState<any>([new Date(new Date().getFullYear(), new Date().getMonth(), 1), new Date()]);
  const [selectedCity, setSelectedCity] = useState({ name: '', code: '' });
  const [selectedDocument, setSelectedDocument] = useState({ name: '', code: '' });
  const [first, setFirst] = useState(0); // State to control the first page
  const [sortField, setSortField] = useState(""); // State to control the first page
  const [sortOrder, setSortOrder] = useState<any>(""); // State to control the first page
  const [rowsPerPage, setRowsPerPage] = useState(5); // State to control the rows per page
  const cities = [
    { name: 'All', code: '' },
    { name: 'Success', code: true },
    { name: 'Failed', code: false },
  ];
  const documents = [
    { name: 'All', code: '' },
    { name: 'Success', code: 'processed_files' },
    { name: 'Pending', code: "unprocessed_files" },
    { name: 'Failed', code: "error_files" },
  ];

  const onGlobalFilterChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setFirst(0);
    const value = e?.target?.value;
    let _filters = { ...filters };

    _filters['global']!.value = value;

    setFilters(_filters);
    setGlobalFilterValue(value);
  };
  const initFilters = () => {
    setFilters({
      global: { value: null, matchMode: FilterMatchMode.CONTAINS }
    });
    setGlobalFilterValue('');
  };
  useEffect(() => {
    dispatch(handleNotFound(false))
    initFilters()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const getDataByHostUrl = async (URL: string, from_date: string, to_date: string, code: any, fileType: string) => {
    dispatch(handleLoader(true));
    try {
      const { result, error } = await getDataByHostURL(URL, from_date, to_date, code, fileType);
      if (error) {
        throw error
      }
      if (result?.error) {
        throw result.error
      }
      setFirst(0);
      setUrlList(result);
      dispatch(handleLoader(false));
    } catch (error: any) {
      dispatch(handleLoader(false));
      setUrlList([]);
      toast.error(error, {
        style: {
          backgroundColor: '#F1F1F1', // Grey background
        }
      });
    }
  }

  const getDataByConnectorName = async (connName: string, clientName: string, from_date: string, to_date: string, code: any, fileType: string) => {
    dispatch(handleLoader(true));
    try {
      const { result, error } = await getDataForConnectors(connName, clientName, from_date, to_date, selectedCity.code, selectedDocument.code)

      if (error) {
        throw error
      }
      if (result?.error) {
        throw result.error
      }
      setUrlList(result);
      dispatch(handleLoader(false));
    } catch (error: any) {
      dispatch(handleLoader(false));
      setUrlList([]);
      toast.error(error, {
        style: {
          backgroundColor: '#F1F1F1', // Grey background
        }
      });
    }
  }

  const temp = (status: any) => {
    if (status === true || status === "processed_files") {
      return "Success"
    } else {
      if (status === false || status === "error_files") {
        return "Failed"
      } else {
        return "Pending"
      }
    }
  }

  const tempClassName = (status: any, is_border: boolean) => {
    if (status === true || status === "processed_files") {
      if (is_border) {
        return "status-tag active_with_border"
      } else {
        return "status-tag active"
      }
    } else {
      if (status === false || status === "error_files") {
        return "status-tag reject"
      } else {
        return "status-tag pending"
      }
    }
  }


  useEffect(() => {
    // getDataByHostUrl((hostUrl && hostUrl!=="" && hostUrl!== null)? hostUrl : "20.20.20.200");
    const url = localStorage.getItem("hosturl");
    const from_date = formateDate(dates[0])
    const to_date = formateDate(dates[1])

    if (dates[1] !== null) {
      if (connState.source === "sftp_doc") {
        getDataByHostUrl(url as any, from_date, to_date, selectedCity.code, selectedDocument.code)
      } else {
        getDataByConnectorName(connState.connector_name as any, connState.client_name, from_date, to_date, selectedCity.code, selectedDocument.code)
      }
    }
  }, [dates, selectedCity, selectedDocument, connState])

  const handleData = (id: string, data: string) => {
    setDynamicId(id);
    setDynamicData(data);
    (data && data !== null) && setVisible(true)
  }

  const handleConnectorName = (c_name: string) => {
    switch (c_name) {
      case 'amazons3':
        return 'Amazon S3';
      case 'servicenow':
        return 'ServiceNow';
      case 'sharepoint':
        return 'SharePoint';
      case 'azureblob':
        return 'Azure Blob';
      default:
        return c_name.charAt(0).toUpperCase() + c_name.slice(1)
    }
  }

  const onClose = () => setVisible(false)

  const downloadFile = async (filePath: any) => {
    // if (base64String) {

    //   const byteCharacters = atob(base64String);
    //   const byteNumbers = new Array(byteCharacters.length);

    //   for (let i = 0; i < byteCharacters.length; i++) {
    //     byteNumbers[i] = byteCharacters.charCodeAt(i);
    //   }

    //   const byteArray = new Uint8Array(byteNumbers);
    //   const blob = new Blob([byteArray], { type: 'text/plain' });

    //   const url = URL.createObjectURL(blob);

    //   const link = document.createElement('a');
    //   link.href = url;
    //   link.download = 'downloadedFile.txt';
    //   document.body.appendChild(link);
    //   link.click();

    //   // Cleanup
    //   document.body.removeChild(link);
    //   URL.revokeObjectURL(url);
    //   toast.success("File is downloaded")
    // }
    try {
      const { result, error } = await getDownloadFile(filePath);
      if (error) {
        throw error;
      }
      if (result?.error) {
        throw result.error;
      }

      // Force download the file
      const blob = new Blob([result]); // Assuming result is the file content
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'filename.extension'); // Set the filename here
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      dispatch(handleLoader(false));
    } catch (error: any) {
      dispatch(handleLoader(false));
      toast.error(error.message, {
        style: {
          backgroundColor: '#F1F1F1', // Grey background
        }
      });
    }
  };


  const chooseColor = (value: string) => {
    if (value === "processed_files") {
      return "#01C324"
    } else if (value === "unprocessed_files") {
      return "#0D6EFD"
    } else if (value === "error_files") {
      return "#F84F4F"
    }
  }


  const chooseColorForBox = (value: any) => {
    if (value === true) {
      return "#01C324"
    } else {
      if (value === false) {
        return "#F84F4F"
      } else {
        return "#0D6EFD"
      }
    }
  }

  const chooseBgColorForBox = (value: any) => {
    if (value === true || value === "processed_files") {
      return "rgb(1 195 36 / 8%)"
    } else {
      if (value === false || value === "error_files") {
        return "rgb(248 79 79 / 10%)"
      } else {
        return "rgb(227,238,255)"
      }
    }
  }

  const handleDateSelection = (e: any) => {
    const selectedDatesArray = e.value;
    if (selectedDatesArray.length === 2) {
      // Update the selected dates when a valid range is selected
      setDates(selectedDatesArray);
      setFirst(0);
    } else {
      // Clear the selection when less than two dates are selected
      setDates([]);
    }
  };

  const handleSort = (event: any) => {
    setSortField(event.sortField)
    setSortOrder(event.sortOrder)
    setFirst(0); // Move to page 1
  };

  useEffect(() => {
    if (visible) {
      document.body?.classList.add("modal-open-vocie");
    } else if (!visible && document.body?.classList?.contains("modal-open-vocie")) {
      document.body?.classList.remove("modal-open-vocie");
    }
  }, [visible])


  return (
    <>
      <div className="datatable-wrapper">
        <div className='p-4 content-wrapper'>
          <div className="switch-section user-management-section">
            <div className='d-flex align-items-center justify-content-between flex-wrap mb-3 table-top-row'>
              <h4 className='mb-0 view-config-heading'>
                <span className='pi pi-chevron-left mr-2 cursor-pointer' onClick={() => {
                  navigate('/admin/pdf-upload')
                }}></span>View Configuration
              </h4>
              <div className="d-flex justify-content-between align-items-center flex-wrap table-right-row">
                <div className='d-flex align-items-center table-right-first'>
                  <div className='d-flex align-items-center mr-3 mt-1 mb-1'>
                    <IconField iconPosition="right" className='user-input'>
                      <InputIcon className="pi pi-search"></InputIcon>
                      <InputText value={globalFilterValue} onChange={onGlobalFilterChange} placeholder="Search by file name" />
                    </IconField>
                  </div>
                  {/* <span className="p-input-icon-left me-sm-2">
                  <i className="pi pi-search" />
                </span> */}
                  <Calendar
                    maxDate={new Date()}
                    value={dates}
                    onChange={handleDateSelection}
                    selectionMode="range"
                    showIcon
                    readOnlyInput
                    hideOnRangeSelection
                    className="user-input mr-3 mt-1 mb-1"
                  />
                </div>
                <div className='d-flex'>
                  <span className='d-flex align-items-center mr-3 mt-1 mb-1'>
                    {/* <label className='me-2' htmlFor="file-status">Doc-Processed:-</label> */}
                    <Dropdown style={{ display: "flex", maxWidth: "154px", justifyContent: "center", alignItems: "center" }} value={selectedDocument} onChange={(e) => { setSelectedDocument(e.value); setFirst(0) }} options={documents} optionLabel="name"
                      placeholder="Doc Processed" className="outline-select" />
                  </span>
                  <span className='d-flex align-items-center mr-3 mt-1 mb-1'>
                    {/* <label className='me-2' htmlFor="file-status">Move-to-Destin:-</label> */}
                    <Dropdown style={{ display: "flex", maxWidth: "154px", justifyContent: "center", alignItems: "center" }} value={selectedCity} onChange={(e) => { setSelectedCity(e.value); setFirst(0) }} options={cities} optionLabel="name"
                      placeholder="Move to Destin" className="outline-select" />
                  </span>
                  <div className="refresh-btn mt-1 mb-1" onClick={() => {
                    setFirst(0)
                    setDates([new Date(new Date().getFullYear(), new Date().getMonth(), 1), new Date()])
                    const url = localStorage.getItem("hosturl");
                    const from_date = formateDate(new Date(new Date().getFullYear(), new Date().getMonth(), 1))
                    const to_date = formateDate(new Date())
                    setSelectedDocument({ name: 'All', code: '' });
                    setSelectedCity({ name: 'All', code: '' })
                    if (dates[1] !== null && connState.source === "sftp_doc") {
                      getDataByHostUrl(url as any, from_date, to_date, "", "");
                    } else {
                      getDataByConnectorName(connState.connector_name as any, connState.client_name, from_date, to_date, selectedCity.code, selectedDocument.code)
                    }

                  }}><i className="fa fa-refresh"></i></div>
                </div>
              </div >
            </div >
            {/* {params.id === "new" &&
              <div className=' flex flex-wrap  align-items-center chat-component-main-container'>
                <div className='flex flex-wrap gap-3 mt-3 align-items-center'>
                </div>
              </div>
            } */}
            < DataTable
              paginator
              filters={filters}
              globalFilterFields={['file_name']}
              first={first}
              onPage={(e) => { setFirst(e.first); setRowsPerPage(e.rows) }}
              rows={rowsPerPage}
              rowsPerPageOptions={[5, 10, 25]}
              stripedRows
              sortField={sortField}
              sortOrder={sortOrder}
              sortMode="single"
              onSort={handleSort}
              value={urlList}
              className='w-full'
              tableStyle={{}} emptyMessage="No records found"
            >

              {/* <Column field="file_name" header="File name" body={(rowData: any) => (<a href="#"
              onClick={(e: any) => {
                e.preventDefault();
                downloadFile(
                  "RnJlcXVlbnRseSBBc2tlZCBRdWVzdGlvbnMgfCBTY3JhcGUgVGhpcyBTaXRlIHwgQSBwdWJsaWMgc2FuZGJveCBmb3IgbGVhcm5pbmcgd2ViIHNjcmFwaW5nIEZyZXF1ZW50bHkgQXNrZWQgUXVlc3Rpb25zIFBsZWFzZSBTY3JhcGUgVGhpcyBTaXRlIFRoaXMgc2l0ZSBpcyBtYWRlIGZvciB0aGUgcHVycG9zZSBvZiB0ZWFjaGluZyBwZW9wbGUgdGhlIGFydCBvZiB3ZWIgc2NyYXBpbmcuIFBsZWFzZSBmZWVsIGZyZWUgdG8gd3JpdGUgb3IgdXNlIHNvZnR3YXJlIGluIG9yZGVyIHRvIGF1dG9tYXRpY2FsbHkgcHVsbCwgaGFydmVzdCwgc2NyYXBlLCBkb3dubG9hZCBvciBvdGhlcndpc2UgYWNjZXNzIGFueSBpbmZvcm1hdGlvbiBvbiB0aGlzIHNpdGUuIFBsZWFzZSBiZSBXZWxsLUJlaGF2ZWQgSnVzdCBsaWtlIGFueSBzaXRlIHlvdSdkIHNjcmFwZSBvdXQgaW4gdGhlIHdpbGQgd2lsZCB3ZXN0ICh3d3cpLCBwbGVhc2UgYmUgbWluZGZ1bCBvZiBvdGhlciB1c2VycyB0cnlpbmcgdG8gYWNjZXNzIHRoZSBzaXRlLiBGcm9tIGEgdGVjaG5pY2FsIHN0YW5kcG9pbnQsIHlvdSBtdXN0IG9ic2VydmUgdGhlIGZvbGxvd2luZyBydWxlczogQ2xpZW50cyBtYXkgb25seSBtYWtlIGEgbWF4aW11bSBvZiBvbmUgcmVxdWVzdCBwZXIgc2Vjb25kIENsaWVudHMgbXVzdCBzZW5kIGFuIGlkZW50aWZ5aW5nIHVzZXIgYWdlbnQgQ2xpZW50cyBtdXN0IHJlc3BlY3QgdGhpcyBzaXRlJ3Mgcm9ib3RzLnR4dCBmaWxlIEFueSBjbGllbnQgdGhhdCB2aW9sYXRlcyB0aGUgcnVsZXMgYWJvdmUgb3Igb3RoZXJ3aXNlIHRyaWVzIHRvIGludGVyZmVyZSB3aXRoIHRoZSBzaXRlJ3Mgb3BlcmF0aW9uIHdpbGwgYmUgc3ViamVjdCB0byBhIHRlbXBvcmFyeSBvciBwZXJtYW5lbnQgYmFuLiBCZSBhIGdvb2Qgd2ViIHNjcmFwaW5nIGNpdGl6ZW4uIPCfkYsgTGVzc29ucyBhbmQgVmlkZW9zIMKpIEhhcnRsZXkgQnJvZHkgMjAyMw==",
                  // rowData.file_name             
                )
                downloadFile(rowData.source_file_path)
              }}
              target="_blank">{rowData.file_name}</a>)} ></Column> */}
              < Column field="file_name" header="File name" sortable={true} ></Column >
              <Column field={connState.source === "sftp_doc" ? "source_host_url" : "connector_name"} header={connState.source === "sftp_doc" ? "Host URL" : "Connector Name"} sortable={connState.source === "sftp_doc" ? true : false} body={(rowData) => (connState.source === "sftp_doc" ? rowData.source_host_url : handleConnectorName(rowData.connector_name))}></Column>
              <Column
                header="Date & Time"
                body={(rowData: any) => (moment(rowData.created_at).format('MMM DD, YYYY HH:mm:ss'))}
                sortable={true}
                sortField='created_at'
              >
              </Column>
              <Column field="file_status" header="Files Transferred to Destination?" sortField='is_processed' showFilterMenu={false} headerStyle={{ width: "10rem" }} filterMenuStyle={{ width: '14rem' }} body={(rowData) => (<Tag className={tempClassName(rowData.file_status, false)} value={temp(rowData.file_status)} />)} />
              <Column field="is_processed" header="Document Processed?" sortField='is_processed' showFilterMenu={false} filterMenuStyle={{ width: '18rem' }} body={(rowData) => (<Tag className={tempClassName(rowData.is_processed, false)} value={temp(rowData.is_processed)} />)} />
              {/* <Column field="is_processed" header="Document Processed?" sortField='is_processed' showFilterMenu={false} filterMenuStyle={{ width: '18rem' }} body={(rowData) => (<Tag style={{ width: "70px", height: "30px", color: chooseColorForBox(rowData.is_processed), backgroundColor: chooseBgColorForBox(rowData.is_processed) }} value={temp(rowData.is_processed)} />)} /> */}

              <Column field="is_NER" header="Entities" sortField='is_NER' showFilterMenu={false} filterMenuStyle={{ width: '18rem' }} body={(rowData) => (<Tag className={tempClassName(rowData.is_NER, true)} style={{ cursor: rowData.is_ner_content !== null && rowData.is_ner_content !== "None" && rowData.is_ner_content !== "null" ? "pointer" : "default" }} onClick={() => { rowData.is_ner_content !== null && rowData.is_ner_content !== "None" && rowData.is_ner_content !== "null" && handleData("Entities", rowData.is_ner_content) }} value={temp(rowData.is_NER)} />)} />
              <Column field="is_summarization" header="Summarization" sortField='is_summarization' showFilterMenu={false} filterMenuStyle={{ width: '18rem' }} body={(rowData) => (<Tag className={tempClassName(rowData.is_summarization, true)} style={{ border: rowData.is_summarization ? "1px solid #6FBE46;" : "", cursor: rowData.is_summarization_content !== null && rowData.is_summarization_content !== "None" && rowData.is_summarization_content !== "null" ? "pointer" : "default" }} onClick={() => { rowData.is_summarization_content !== null && rowData.is_summarization_content !== "None" && rowData.is_summarization_content !== "null" && handleData("Summarization", rowData.is_summarization_content) }} value={temp(rowData.is_summarization)} />)} />

              <Column field="is_classification" header="Classification" sortField='is_classification' showFilterMenu={false} filterMenuStyle={{ width: '18rem' }} body={(rowData) => (<Tag className={tempClassName(rowData.is_classification, true)} style={{ border: rowData.is_classification ? "1px solid #6FBE46;" : "", cursor: rowData.is_classification_content !== null && rowData.is_classification_content !== "None" && rowData.is_classification_content !== "null" ? "pointer" : "default" }} onClick={() => { rowData.is_classification_content !== null && rowData.is_classification_content !== "None" && rowData.is_classification_content !== "null" && handleData('Classification', rowData.is_classification_content) }} value={temp(rowData.is_classification)} />)} />
            </DataTable >
          </div >
        </div >
      </div >
      <DataShowModal visible={visible} close={onClose} d_data={dynamicData} d_id={dynamicId} />
    </>
  )
}

export default FileConfig